import { RefreshOutlined } from '@mui/icons-material'
import { Button } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import Filter from 'components/Filter'
import Paper from 'components/Paper'
import { TableHeader, usePagination } from 'components/Table'
import { reportsQueryKey } from 'features/yieldbirdWrapperAgent/api/queries'
import { ReportsTable } from 'features/yieldbirdWrapperAgent/components/ReportsTable'

import type { FilterValue } from 'components/Filter'

export const ReportsSection = (): React.JSX.Element => {
  const { t } = useTranslation('features/yieldbirdWrapperAgent', { keyPrefix: 'reports' })
  const queryClient = useQueryClient()
  const [filters, setFilters] = useState<FilterValue[]>([])
  const pagination = usePagination()

  const handleFiltersChange = (values: FilterValue[]): void => {
    setFilters(values.slice(-1)) // API supports only one filter
    pagination.setPage(1)
  }

  const ReportsFilter = (
    <Filter
      id='reports-filter'
      onChange={handleFiltersChange}
      placeholder={t('filter')}
      values={filters}
    />
  )

  const RefreshButton = (
    <Button
      data-cy='reports-refresh-button'
      onClick={(): void => void queryClient.invalidateQueries({ queryKey: reportsQueryKey })}
      size='small'
      startIcon={<RefreshOutlined />}
      variant='outlined'
    >
      {t('refresh')}
    </Button>
  )

  return (
    <Paper>
      <TableHeader
        actions={RefreshButton}
        description={t('description')}
        filter={ReportsFilter}
        title={t('title')}
      />

      <GapBox />

      <ReportsTable
        filters={filters}
        pagination={pagination}
      />
    </Paper>
  )
}
